<template>
  <div class="cc-address-select cc-form-input position-relative">
    <select
        :value="selected"
        class="cc-input cc-input--select cc-input--full-width"
        @change="$emit('addressSelected', $event.target.value)"
    >
      <option value="0">Zadejte adresu nebo vyberte ze seznamu</option>
      <option v-for="address in user.addresses" :key="address.id_address" :value="address.id_address">
        {{ address.alias }} - {{ address.address1 }}, {{ address.city }}
      </option>
    </select>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      user: state => state.user,
    }),
  },
  props: [
      'selected'
  ]
}
</script>
<style lang="scss" scoped="scoped">
  @import "./scss/global/main.scss";
  .cc-address-select.cc-form-input select {
    background: #009cb0;
    color: white;
    font-weight: bold;
  }
  .cc-address-select.cc-form-input:after {
    content: "\F107";
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: 26px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: absolute;
    right: 1rem;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 26px;
    color: white;
    font-weight: bold;
    pointer-events: none;
  }
  select option {
    background: white;
    color: #000000;
  }
  @media (min-width: 1200px) {
    .cc-input.cc-input--select{
      padding: 1.25rem 3rem 1.25rem 1.5rem;
    }
  }
</style>